import { LitElement, html } from "lit-element";
import '@material/mwc-button';
import { colorTheme } from '../styles/color-theme';


export class InspxDialog extends LitElement {
	render() {
		if(!this.opened) return html``;
        
		if (this.overlay) {
			if (!this.classList.contains('overlay')) this.classList.add('overlay');
		} else if (this.classList.contains('overlay')) this.classList.remove('overlay');

		return html`
        ${colorTheme}
            <style>    
                :host {
                    position: fixed;
                    min-width: 100%;
                    min-height: 100%;
                    top: 0;
                    left: 0;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    z-index: 9999;
                }

                :host(.overlay) {
                    background-color: rgba(0, 0, 0, 0.2);
                }

                .dialog {
                    display: flex;
                    max-width: 500px;
                    max-height: 90vh;
                    background-color: var( --secondary-color);
                    box-shadow: grey 0px 0px 8px 2px;
                    color: white;
                    flex-direction: column;
                    padding: 20px;
                    border-radius: 6px;
                }

                .c {
                    margin-top: 20px;
                    margin-bottom: 20px;
                    overflow-y: auto;
                }

                .h{ 
                    font-size: large;
                    font-weight: bold;
                }

                .f {
                    --mdc-theme-primary: white;            
                    --mdc-theme-on-primary: var(--pd-color-dark);     
                    --mdc-theme-on-primary:  #3d4854;               
                    display: flex;
                    justify-content: flex-end;
                    flex-direction: row;
                }

                .f > mwc-button {
                    margin: 2px;
                }
            </style>
            <div class="dialog" @click="${this.cancelClick}" @keydown="${(e) => this._keyDown(e)}">
                <div class="h">${this.headerLabel}</div>
                <div class="c">
                    ${this.content}
                    <slot></slot>
                </div>
                <div class="f">
                    ${this.cancellable ? html`
                        <mwc-button @click="${(e) => this.close({ cancel: true })}">${this.cancelLabel}</mwc-button>
                    ` : null}
                    <mwc-button class="acceptBtn" id="acceptBtn" raised   @click="${() => this.close({ accept: true })}">${this.acceptLabel}</mwc-button>
                </div>
            </div>
        `;
	}

	cancelClick(e) {
		e.preventDefault();
		e.stopPropagation();
		return false;
	}

	updated() {
		var b = this.shadowRoot.getElementById("acceptBtn");
		if (b) {
			b.focus();
		}
	}

	firstUpdated() {
		// document.body.scrollTop = 0;
		// document.documentElement.scrollTop = 0;
	}

	open() {
		this.opened = true;
	}

	close(e) {

		if (!e) {
			return;
		}

		if (e.cancel === true || e.accept === false) {
			this.dispatchEvent(new CustomEvent('dialog-cancel', { detail: {} }));
		}
		if (e.accept === true) {
			this.dispatchEvent(new CustomEvent('dialog-accept', { detail: {} }));
		}

		this.opened=false;
	}

	_keyDown(e) {
		// enter pressed
		if (e.keyCode === 13) {
			this.close({ accept: true });
		}
		// escape pressed
		if (e.keyCode === 27) {
			this.close({ cancel: true });
		}
	}

	connectedCallback() {
		super.connectedCallback();
		document.body.classList.add('freeze-scroll');
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		document.body.classList.remove('freeze-scroll');
	}

	constructor() {
		super();
		this.opened = true;
		this.overlay = true;
		this.cancellable = false;
		this.headerLabel = "Confirmation";
		this.acceptLabel = "YES";
		this.cancelLabel = "NO";
		this.content = '';
		this.addEventListener('click', () => this.close({ cancel: true }));
	}

	static get properties() {
		return {
			opened: { type: Boolean },
			overlay: { type: Boolean },
			content: { type: String },
			cancellable: { type: Boolean },
			headerLabel: { type: String },
			acceptLabel: { type: String },
			cancelLabel: { type: String },
		};
	}
}

window.customElements.define("inspx-dialog", InspxDialog);
